import { BlogPostsList, BlogPostsListData } from "../shared";

export interface BlogCategoryListSectionData {
  posts: {
    id: string;
    title: string;
    slug: string;
    content: string;
    author: {
      slug: string;
      title: string;
    };
    categories: {
      blog_categories_id: {
        slug: string;
        title: string;
      };
    }[];

    published_at: string;
    featured_image?: {
      id: string;
      filename_download: string;
    };
  }[];
  total: number;
  categorySlug: string;
  totalPages: number;
  currentPage: number;
  left_column_data: any;
  categories: {
    id: string;
    slug: string;
    title: string;
  }[];
  archives: {
    date: string;
    count: number;
  }[];
}

interface BlogCategoryListSectionProps {
  data: BlogCategoryListSectionData;
}

export default function BlogCategoryListSection({
  data,
}: BlogCategoryListSectionProps) {
  // Transform data to match BlogPostsList interface
  const blogPostsListData: BlogPostsListData = {
    posts: data.posts.map((post) => ({
      ...post,
      featured_image: post.featured_image
        ? {
            id: post.featured_image.id,
            filename_download: post.featured_image.filename_download,
          }
        : undefined,
    })),
    total: data.total,
    totalPages: data.totalPages,
    currentPage: data.currentPage,
    categories: data.categories,
    archives: data.archives,
    categorySlug: data.categorySlug,
    left_column_data: data.left_column_data,
  };

  const paginationBaseUrl = `/${process.env.NEXT_PUBLIC_BLOG_SLUG}/${process.env.NEXT_PUBLIC_BLOG_CATEGORY_SLUG}/${data.categorySlug}`;

  return (
    <BlogPostsList
      data={blogPostsListData}
      paginationBaseUrl={paginationBaseUrl}
      showEmptyState={true}
    />
  );
}
